<template>
  <div @click="onClose" id="modal_wrap">
    <div class="modal_container">
      <div class="swal2-header">
        <div class="swal2-icon swal2-info swal2-animate-info-icon" style="display: flex;"></div>
      </div>
      <form @submit="onAccept">
        <div class="modal_header">
          <h3>{{ modalData.header }} - Заявка <strong>{{ modalData.order.id }}</strong></h3>
        </div>
        <div class="modal_body">

          <p v-if="modalData.text">{{ modalData.text }}</p>

          <div v-if="modalData.type === 'comment'">
            <div v-for="comment in modalData.order.comment">
              <p class="text-left">{{ comment.text }}</p>
              <p class="text-muted text-right">{{ comment.created_at }}: {{ comment.user_name }}</p>
              <hr>
            </div>
          </div>
          <div v-if="modalData.type === 'comment' || modalData.type === 'reject'">
            <input required v-model="modalData.comment" class="form-control" placeholder="Комментарий"/>
          </div>

          <div v-if="errorMessage">
            <p class="error_messages">{{ errorMessage }}</p>
          </div>

        </div>
        <div class="modal_actions">
          <vue-ladda button-class="btn btn-success"
                     data-style="zoom-in"
                     type="submit"
                     :loading="acceptBtnLoading">{{ modalData.acceptBtnText }}
          </vue-ladda>
          <button @click="onReject" class="btn btn-default">{{ modalData.cancelBtnText || 'Отмена' }}</button>
        </div>
      </form>
      <div class="modal_footer"></div>
    </div>
  </div>
</template>

<script>

import VueLadda from 'vue-ladda/src/vue-ladda.vue'

export default {
  components: {
    VueLadda,
  },
  props: [
    'onModalClose', 'onModalAccept', 'modalData'
  ],
  data() {
    return {
      text: null,
      acceptBtnLoading: false,
      errorMessage: null,
    }
  },
  mounted() {
  },
  methods: {
    onAccept(e) {
      e.preventDefault();
      this.errorMessage = null;
      let err = false;
      if (err) return;
      this.acceptBtnLoading = true;
      this.onModalAccept(this.text, this.modalData.type);
    },
    onReject(e) {
      this.onModalClose();
    },
    onClose(e) {
      if (!this.acceptBtnLoading && e.target.id === 'modal_wrap' && !this.acceptBtnLoading) {
        this.onModalClose();
      }
    }
  }
}

</script>

<style scoped>
hr {
  margin-bottom: 2px;
  margin-top: 2px;
}

p {
  margin-bottom: 2px;
}

p.text-muted {
  font-size: 11px;
}

.error_messages {
  color: red;
}

.btn-xs {
  font-size: 12px !important;
  padding: 3px 10px !important;
}

.btn {
  margin: 10px;
  padding: 7px 25px;
  font-size: 24px;
}

#modal_wrap {
  display: none;
  position: fixed;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.55);
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal_body {
  z-index: 1;
  justify-content: center;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 1.125em;
  font-weight: 400;
  line-height: normal;
  text-align: center;
  word-wrap: break-word;
}

.modal_header {
  position: relative;
  max-width: 100%;
  margin: 0 0 .4em;
  padding: 0;
  color: #595959;
  font-size: 1.875em;
  font-weight: 600;
  text-align: center;
  text-transform: none;
  word-wrap: break-word;
}

.modal_actions {
  display: flex;
  z-index: 1;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 1.25em auto 0;
}

.modal_container {
  background-color: white;
  padding: 20px;
  /*min-width: 500px;*/
  width: fit-content;
}
</style>
